import React from 'react'
// import { Link } from 'react-router-dom'
import MarkdownWrapper from '../utils/markdown-wrapper'

const CharacterCarouselTile = ({ character, handleStoryClick }) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault()
            handleStoryClick(character.uuid)
        }
    }

    return (
        <button
            className={`character-box-carousel character-${character.displayOrder}`}
            onClick={() => handleStoryClick(character.uuid)}
            onKeyDown={handleKeyDown}
            aria-label={`Learn about ${character.firstName} ${character.lastName}`}
        >
            <div className="character-image">
                <div className="background">
                    <img src={character.background.url} alt={character.background.alt} />
                </div>
                <div className="middle">
                    <img src={character.middleground.url} alt={character.middleground.alt} />
                </div>
                <div className="foreground">
                    <img src={character.headshot.url} alt={character.headshot.alt} />
                </div>
            </div>
            <div className="character-description">
                <span className="full-name">
                    {character.firstName} {character.lastName}
                </span>
                <div className="overview">
                    <MarkdownWrapper content={character.overview} />
                </div>
            </div>
        </button>
    )
}

export default CharacterCarouselTile
